<app-dyn-form #dynForm [key]="'attachments'" [model]="model" [showTitle]="false" [isEditMode]="true" [autoSave]="true"
    (result)="onSubmit($event)"> </app-dyn-form>